<template>
  <div class="page noselect">
    <v-container grid-list-md>

      <div class="text-center mt-7">
        <h4>DEBUG PARAMS</h4>

        <div class="spacer-15"></div>

        <div>
          PROD_ENV: {{ PROD_ENV }}
        </div>
        <div>
          isDev: {{ isDev }}
        </div>

        <div>
          table: {{ table }}
        </div>
        <div>
          availableOrderModes: {{JSON.stringify($store.getters.availableOrderModes)}}
        </div>
        <div>selectedOrderModeByUser: {{ $store.getters.selectedOrderModeByUser}}</div>

        <div class="spacer-15"></div>

        <div>
          Auflösung: {{ innerWidth }}x{{ innerHeight }}<br>
          devicePixelRatio: {{ devicePixelRatio }}<br>
        </div>
        <div>
          storagePersist: {{storagePersist}}
        </div>
        <div>
          swActive: {{$store.getters.swActive}}
        </div>
        <div>
          withPosApi: {{ withPosApi }}
        </div>
        <div>
          isKiosk: {{ $store.getters.isKiosk }}
        </div>
        <div>
          showKioskSplashOnHome: {{ $store.getters.showKioskSplashOnHome }}
        </div>
        <div>
          enableKioskInhouseMitPay: {{ enableKioskInhouseMitPay }}
        </div>
        <div>
          enableKioskInhousePayMitTip: {{ enableKioskInhousePayMitTip }}
        </div>
        <div>
          enableKioskInhouseOhnePay: {{ enableKioskInhouseOhnePay }}
        </div>
        <div>
          enableKioskTakeAwayMitPay: {{ enableKioskTakeAwayMitPay }}
        </div>
        <div>
          enableKioskTakeAwayOhnePay: {{ enableKioskTakeAwayOhnePay }}
        </div>

        <div>
          isoe: {{ isoe }}
        </div>
        <div>
          isIos: {{ isIos }}
        </div>
        <div>
          loggedIn: {{ $store.getters.loggedIn }}
        </div>
        <div>
          <div class="pt-2 pb-2 d-inline-block text-left renderLineBreaks">
            <b>Stempelkarte:</b>
            {{ JSON.stringify($store.getters.stempelkarte, null, 2) }}
          </div>
        </div>
        <div>
          selfServiceEnabled: {{ selfServiceEnabled }}
        </div>
        <div>
          enableSelfServiceExtras: {{ enableSelfServiceExtras }}
        </div>
        <div>
          isInhouse: {{ isInhouse }}
        </div>
        <div>
          orderingEnabled: {{ orderingEnabled }}
        </div>
        <div>
          tipEnabled: {{ tipEnabled }}
        </div>
        <div>
          takeawayOrderingEnabled: {{ takeawayOrderingEnabled }}
        </div>
        <div>
          inhouseOrderingEnabled: {{ inhouseOrderingEnabled }}
        </div>
        <div>
          deliveryOrderingEnabled: {{ deliveryOrderingEnabled }}
        </div>

        <div>
          enableInhousePay: {{ enableInhousePay }}
        </div>
        <div>
          enableInhouseOhnePay: {{ enableInhouseOhnePay }}
        </div>
        <div>
          enableTakeawayPay: {{ enableTakeawayPay }}
        </div>
        <div>
          enableTakeawayOhnePay: {{ enableTakeawayOhnePay }}
        </div>
        <div>
          enableDeliveryPay: {{ enableDeliveryPay }}
        </div>
        <div>
          enableDeliveryOhnePay: {{ enableDeliveryOhnePay }}
        </div>

        <div>
          <div class="pt-2 pb-2 d-inline-block text-left renderLineBreaks">
            <b>Abholzeiten:</b>
            {{ JSON.stringify($store.getters.appconfig.takeAway.openingHours, null, 2) }}
          </div>
        </div>

        <div>
          <div class="pt-2 pb-2 d-inline-block text-left renderLineBreaks">
            <b>Lieferzeiten:</b>
            {{ JSON.stringify($store.getters.appconfig.delivery.openingHours, null, 2) }}
          </div>
        </div>

      </div>


    </v-container>
  </div>
</template>

<script>
import store from '../store/store'
import {
  enableKioskInhouseMitPay,
  enableKioskInhouseOhnePay,
  enableKioskInhousePayMitTip,
  enableKioskTakeAwayMitPay, enableKioskTakeAwayOhnePay, isDev, PROD_ENV, withPosApi
} from "../vendor/qconstants";
import {isIos} from "../vendor/util";

export default {
  data: () => ({
    PROD_ENV: PROD_ENV,
    isDev: isDev,
    devicePixelRatio: window.devicePixelRatio,
    storagePersist: 'loading',
    // 1. Logische Auflösung (Was der Browser "denkt", wie groß er ist)
    innerWidth: window.innerWidth,
    innerHeight: window.innerHeight,

    withPosApi: withPosApi,
    enableKioskInhouseMitPay: enableKioskInhouseMitPay,
    enableKioskInhousePayMitTip: enableKioskInhousePayMitTip,
    enableKioskInhouseOhnePay: enableKioskInhouseOhnePay,
    enableKioskTakeAwayMitPay: enableKioskTakeAwayMitPay,
    enableKioskTakeAwayOhnePay: enableKioskTakeAwayOhnePay,
  }),
  mounted() {
    this.checkStoragePersist();
  },
  computed: {
    isoe() {
      return !!window.isoe
    },
    selfServiceEnabled() {
      return this.$store.getters.selfServiceEnabled;
    },
    enableSelfServiceExtras() {
      return store.state.enableSelfServiceExtras
    },
    isInhouse() {
      return !!this.$store.getters.inhouse
    },
    table() {
      return this.$store.getters.table
    },
    isIos() {
      return !!isIos()
    },
    orderingEnabled() {
      return this.$store.getters.orderingEnabled;
    },
    tipEnabled() {
      return store.state.enableTip;
    },
    takeawayOrderingEnabled() {
      return this.$store.getters.takeawayOrderingEnabled;
    },
    inhouseOrderingEnabled() {
      return this.$store.getters.inhouseOrderingEnabled;
    },
    deliveryOrderingEnabled() {
      return this.$store.getters.deliveryOrderingEnabled;
    },

    enableInhouseOhnePay() {
      return this.$store.getters.enableInhouseOhnePay;
    },
    enableInhousePay() {
      return this.$store.getters.enableInhousePay;
    },
    enableTakeawayPay() {
      return this.$store.getters.enableTakeawayPay;
    },
    enableTakeawayOhnePay() {
      return this.$store.getters.enableTakeawayOhnePay;
    },
    enableDeliveryPay() {
      return this.$store.getters.enableDeliveryPay;
    },
    enableDeliveryOhnePay() {
      return this.$store.getters.enableDeliveryOhnePay;
    },
  },
  methods:{
    async checkStoragePersist() {
      try {
        console.log('checkStoragePersist...');
        if (navigator.storage && navigator.storage.persist) {
          const persistent = await navigator.storage.persist();
          this.$nextTick(() => {
            this.storagePersist = !!persistent;
          });
        }
      } catch (error) {
        console.error('An error occurred checking StoragePersist:', error);
      }
    },
  }
}
</script>

<style scoped lang="scss">

</style>
